// extracted by mini-css-extract-plugin
module.exports = {"screen":"_1rw5B8 mz-default-dark-font"};